import {
    getSelectedCover,
    getCustomerIdValue,
    getVehicleRecordIdValue,
    getInsuranceQuotationIdValue,
    getPremiumCalculationUg,
} from '../../../selectors/ugMotorInsurance/quote';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import {
    getAccessToken,
    getPaymentStatusData,
    getPaymentMode,
    getConfirmOrderData,
} from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/ugMotorInsurance/types';
import { setBankDetailsSuccess } from '../../../actions/ugMotorInsurance/payments';
import { orderConfirmationService } from './orderConfirmation';

export const submitPaymentDetailsService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const state = store.getState();

                const selectedCover = getSelectedCover(state);

                let resp;

                if (selectedCover?.value === COVER_PLANS.MOTOR_COMPREHENSIVE.value) {
                    resp = await makeComprehensiveSubmission(state);
                }

                if (selectedCover?.value === COVER_PLANS.THIRD_PARTY.value) {
                    resp = await makeThirdPartySubmission(state);
                }

                if (resp.data) {
                    store.dispatch(apiTransitionPayloadCollection.success());

                    const paymentsData = getPaymentStatusData(store.getState());

                    const modeOfPayment = getPaymentMode(store.getState());

                    const transactionRef = paymentsData?.CheckoutRequestID || 'N/A';

                    const orderData = getConfirmOrderData(store.getState());

                    if (modeOfPayment === 'Mpesa' && transactionRef !== 'N/A' && !orderData?.base64) {
                        orderConfirmationService(store, next, action);
                    }

                    if (modeOfPayment === 'Bank') {
                        store.dispatch(setBankDetailsSuccess(true));
                    }
                }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPayloadCollection.failure());
            }
        }
    })();
    return next(action);
};

const comprehensivePayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);
    const premium = getPremiumCalculationUg(state);
    const paymentsData = getPaymentStatusData(state);
    const modeOfPayment = getPaymentMode(state);

    const paymentDetailsPayload = {
        insurance_id: customerId.value,
        quotation_id: insuranceQuotationId.value,
        vehicle_id: vehicleRecordId.value,
        amount: premium.value.premium || premium.value.totalPremium,
        transactionRef: paymentsData?.CheckoutRequestID || 'N/A',
        modeOfPayment: modeOfPayment ? modeOfPayment : 'N/A',
    };

    return {
        ...paymentDetailsPayload,
    };
};

const makeComprehensiveSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/comprehensive/payment';

        return await axios.post(url, comprehensivePayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

const thirdPartyPayloadCollection = (state) => {
    const customerId = getCustomerIdValue(state);
    const premium = getPremiumCalculationUg(state);
    const paymentsData = getPaymentStatusData(state);
    const modeOfPayment = getPaymentMode(state);

    const paymentDetailsPayload = {
        id: customerId.value,
        amount: premium.value.premium || premium.value.totalPremium,
        transactionRef: paymentsData?.CheckoutRequestID || 'N/A',
        modeOfPayment: modeOfPayment ? modeOfPayment : 'N/A',
    };

    return {
        ...paymentDetailsPayload,
    };
};

const makeThirdPartySubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-motor-insurance/third-party/payment';

        return await axios.post(url, thirdPartyPayloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
